import { IExportDeductionRepository, IExportDeductionRequest } from "@/core/repositories/export/export.deduction";

export class ExportDeductionUseCase {
  constructor(private readonly exportDeductionRepository: IExportDeductionRepository) {}

  async execute(body: IExportDeductionRequest): Promise<{ signedUrl: string; success: boolean }> {
    return this.exportDeductionRepository.exportDeduction(body);
  }
}
